import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { Firmware } from 'app/models/firmware.model';
import { User } from 'app/models/user.model';
import { FirmwareService } from 'app/services/firmware.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FirmwareFormComponent } from '../firmware-form/firmware-form.component';

@Component({
    selector: 'firmware-list',
    templateUrl: './firmware-list.component.html',
    styleUrls: ['./firmware-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class FirmwareListComponent implements OnInit {
    widgets: any;

    private _lastFirmware: Firmware;

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    public user: User;
    private _firmwareList: Array<Firmware> = [];
    public get firmwareList(): Array<Firmware> {
        return this._firmwareList;
    }

    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }


    private _dataSource: MatTableDataSource<Firmware> = undefined;
    public get dataSource(): MatTableDataSource<Firmware> {
        return this._dataSource;
    }

    private _displayedColumns = ['id', 'model', 'version', 'fileName', 'packetSize', 'endSize', 'uDate', 'setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _firmwareService: FirmwareService,
        private _spinner:NgxSpinnerService,
        private _dialog: MatDialog,
        private _toastService: ToasterService,
    ) {

    }


    public async ngOnInit() {

        await this.getFirmwareList();
        this.updateTableDataSource();
    }
    private async getFirmwareList(): Promise<Array<Firmware>> {
        try {
            this._spinner.show('loading');
            this._firmwareList = await this._firmwareService.getFirmwareCompany(parseInt(localStorage.getItem("CompanyID")));
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Firmware>(this._firmwareList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public addFirmware() {
        const dialog = this._dialog.open(FirmwareFormComponent, {
            data: new Firmware(),
            disableClose: false,
            maxHeight:'80vh'
        });

        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }

    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
    async deleteFirmware(firmware: Firmware) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen firmware silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                await this._firmwareService.delete(firmware);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })
            
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);

        }
        this.refresh();
    }
    refresh() {
        this.getFirmwareList();
    }
}
